<template>
  <div class="iv-main-width">
    <!-- <Row class-name="iv-main-width"> -->
    <Tab :value="value" :navList="navList" @on-click="tabClick" class="iv-home-list"></Tab>
    <!-- </Row> -->
  </div>
</template>

<script>
import Tab from '@/components/tab'
import info from './info.js'

export default {
  data() {
    return {
      value: this.$route.query.categoryCode,
      navList: [{
        label: '首页',
        name: 'homePage'
      }]
    }
  },
  watch: {
    '$route'(val) {
      this.value = val.name
    }
  },
  mounted() {
  },
  created() {
    this.navList = info.call(this)
    this.initTabs()
  },
  // directives: { clickoutside },
  computed: {},
  methods: {
    tabClick(name) {
      let tabItem = this.navList.find((item) => (item.name == name))
      if (name == 'homePage') {
        this.toIndexPage()
      } else {
        //把点击的值传过去
        this.toNextPage(tabItem)
      }
      
    },
    initTabs() {
      this.$ajax({
        url: 'api-qixuan/cms/front/getColumn2List',
        method: 'get',
        data: {
          siteId:'95',//党群新闻站点id，
          id:0
        }
      }).then(({data}) => {
        sessionStorage.setItem('userCode',data.userCode)
        this.navList = [{
          label: '首页',
          name: 'homePage'
        }]
        data.data.map(item => {
          this.navList.push({
            label: item.name,
            name: item.columnCode,
            categoryId: item.id,
            categoryType: item.type
          })
        })
        /*this.navList.push({
          label: '文化专区',//TODO: 导航最后增加一个
          name: 'homePagse'
        })*/
        if (this.$route.name == 'homePage') {
          this.$router.push({
            name: 'homePage'
          })
        }
        this.getHomeAbout()
      })
    },
    getHomeAbout() {
      this.$ajax({
        url: 'api-qixuan/cms/front/getColumn2List',
        method: 'get',
        data: {
          siteId:'95',//党群新闻站点id，
          id:'0' 
        }
      }).then(({data}) => {
        let navData = {}
        data.data.map(item => {
          navData[item.columnCode] = {
            label: item.name,
            name: item.columnCode,
            categoryId: item.id,
            categoryType: item.type
          }
        })
        // console.log('navData>>>', navData)
        this.$emit('nav-data', navData)
      })
    },
    // ...mapMutations([
    //   'SKINLAYOUT',
    //   'ISNEWMESSAGE'
    // ])
    //面包屑跳转  路由跳转
    toNextPage(item) {
      let name=item.name
      let haveRouter=false
      if(this.$router.options.routes[2].name=='newsCenter'){
        for (let i=0; i < this.$router.options.routes[2].children.length; i++) {
          if(name==this.$router.options.routes[2].children[i].name) {
            haveRouter=true
            console.log("haveRouter")
          }
        }
      }else{
        haveRouter=true
      }
      if (this.currentRouteName === item.name) return
      this.$router.push({
        name: haveRouter?name:'columns',
        query: {
          categoryType: item.categoryType,
          categoryCode: name,
          categoryId: item.categoryId,
          categoryName: item.label
        }
      })
    },
    onUserClick(name) {
    },
    //跳转首页
    toIndexPage() {
      this.$router.push('/homePage')
    },
    onOprateClick() {
      //this.getMessageList()
    },
    setIsNewMsg(type) {
      this.isNewMsg = type
    }
  },
  components: {
    Tab
  }
}
</script>
